// Router
import router from "@/router";
// Store
import store from "@/store";
import { SET_LIST } from "@/store/mutations-types";
import { USER_ACTIONS } from "@/store/modules/User/types";
import { LIST_ACTIONS } from "@/store/modules/List/types";
import { SUBSCRIPTIONS_ACTIONS } from "@/store/modules/Subscriptions/types";
// Services
import httpService from "@/services/http";

export default async function logout(): Promise<void> {
  try {
    await httpService.logout();
  } finally {
    // Leave the page first so mounted components stop polling before the user state is reset
    try {
      await router.replace({ name: "Auth" });
    } catch {
      // Navigation failed (e.g. chunk load error) - still proceed with cleanup
    }
    httpService.clearCache();
    store.commit(USER_ACTIONS.RESET_USER);
    store.commit(SET_LIST, {
      name: LIST_ACTIONS.MODULE_LIST,
      list: [],
    });
    await store.dispatch(SUBSCRIPTIONS_ACTIONS.UNSUBSCRIBE_ALL);
  }
}
